/* eslint-disable prefer-const */
import Vue from 'vue'
// 引入 ECharts 主模块
const echarts = require('echarts/lib/echarts')
require('./echarts-plugin')
// 引入折线图/柱状图等组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/radar')
require('echarts/lib/chart/pie')
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll')// 图例滚动
// vue全局注入echarts
Vue.prototype.$echarts = echarts
